module.exports = __webpack_public_path__ + "img/technician.ac5987a6.jpg";